/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

const WyConstants = {
  systemCompanyCode: 1,
  SESSION_SITE_KEY: 'ops-center-site',
  SESSION_SITE_KEY_BA: 'ops-center-site-ba',
  SESSION_SITE_KEY_IA: 'ops-center-site-ia',
  SESSION_SITE_KEY_AQ: 'ops-center-site-aq',
  SESSION_SITE_KEY_AS: 'ops-center-site-as',
  SESSION_SITE_KEY_ST: 'ops-center-site-st',
  SESSION_AUTH_USER: 'AUTH_USER',
  SESSION_CURRENT_ROUTE_PATH: 'ops-center-default-path',

  BLANK_LABEL: 'Unknown',
  USE_OC_CONFIGURATION_API: true,

  PRODUCT_NAME_ST: 'st',
  PRODUCT_NAME_AS: 'as',
  PRODUCT_NAME_AQ: 'aq',
  PRODUCT_NAME_IA: 'ia',
  PRODUCT_NAME_BA: 'ba',
  PRODUCT_NAME_OC: 'oc',
  PRODUCT_NAME_APP: 'app',
  C1_DEV_MODE: null,

  EVENT_MESSAGE_CHANNEL_MEDIAPLAYER: 'C1MediaPlayer',
  MEDIAPLAYER_AUTOQA_SELECTED_FORMID: 'mediaPlayerAutoQASelectedFormId',
  MEDIAPLAYER_AUTOQA_SELECTED_FORMID_FOR_SUMMARY: 'mediaPlayerAutoQASelectedFormIdForSummary',
  CONV_INTELLIGENCE_PROPS_STORAGE_KEY: "convIntelligenceiFrameProps",

  EVENT_MESSAGE_CHANNEL_APP: 'EVENT_MESSAGE_CHANNEL_APP',
  EVENT_MESSAGE_ACTION_APP_INIT: 'EVENT_MESSAGE_ACTION_APP_INIT',
  EVENT_MESSAGE_ACTION_APP_INIT_CALLBACK: 'EVENT_MESSAGE_ACTION_APP_INIT_CALLBACK',

  SERVER: {
    ACCESS_HOST: `${window.location.origin}/studio`,
    ANALYTICS_HOST: `${window.location.origin}/studio/api`,
    INTERACTIONS_HOST: `${window.location.origin}/studio/api`,
    SMART_TAGS_HOST: `${window.location.origin}/studio/api`,
    OPTIMIZATION_HOST: `${window.location.origin}/studio/api`,
    PERFORMANCE_HOST: `${window.location.origin}/studio/api`,
    CUSTOMER_HOST: `${window.location.origin}/studio/api`,
    FLOW_HOST: `${window.location.origin}/studio/api`,
  },

  ALERT_METRICS: {
    // overall
    monthlyUsage: {
      label: 'Monthly limit summary',
      section:'Auto QM',
      access: null
    },
    nearOverage: {
      label: 'Monthly limit almost reached',
      section:'Auto QM',
      access: null
    },
    overage: {
      label: 'Monthly limit reached',
      section:'Auto QM',
      access: null
    },
    monthlyNoUsage: {
      label: 'No monthly usage',
      section:'Auto QM',
      access: null
    },
    bes: {
      label: 'Bot Experience Score',
      section:'Home',
      reverse: false,
      access: [4000, 4001]
    },
    bas: {
      label: 'Bot Automation Score',
      section:'Home',
      reverse: false,
      access: [4000, 4001]
    },
    vaVolume: {
      label: 'Total VA Conversations',
      section:'Home',
      reverse: false,
      access: [4000, 4001]
    },
    vaContainedVolume: {
      label: 'VA Conversations Contained',
      section:'Virtual Agent Analytics',
      reverse: false,
      access: [4100, 4101, 4110, 4111]
    },
    totalMessages: {
      label: 'Customer Messages',
      section:'Virtual Agent Analytics',
      reverse: false,
      access: [4100, 4101, 4110, 4111]
    },
    containedConversationsTrueResolvedVolume: {
      label: 'True Resolved',
      section:'Virtual Agent Analytics',
      reverse: false,
      access: [4100, 4101, 4110, 4111]
    },
    negativeFeedbackScore: {
      label: 'Negative Feedback Score',
      section:'Virtual Agent Analytics',
      reverse: true,
      access: [4100, 4101, 4110, 4111]
    },
    understandingPercent: {
      label: 'NLU',
      section:'Virtual Agent Analytics',
      reverse: false,
      access: [4100, 4101, 4110, 4111]
    },
    // topics
    avgBes: {
      label: 'Bot Experience Score',
      section:'Conversation Analytics',
      reverse: false,
      access: [4200, 4201]
    },
    avgBas: {
      label: 'Bot Automation Score',
      section:'Conversation Analytics',
      reverse: false,
      access: [4200, 4201]
    },
    avgAes: {
      label: 'Agent Experience Score',
      section:'Conversation Analytics',
      reverse: false,
      access: [4200, 4201]
    },
    volume: {
      label: 'Volume',
      section:'Conversation Analytics',
      reverse: false,
      access: [4200, 4201]
    },
    containment: {
      label: 'Containment',
      section:'Conversation Analytics',
      reverse: false,
      access: [4200, 4201]
    }
  },
  SIGNAL_PAYLOAD_MAPPER: {
    'experience': {
      'Bot Repetition': 'hasBotRepetitionSignal',
      'User Abandoned': 'hasAbandonedByUserSignal',
      'Negative Sentiment': 'hasNegativeSentimentSignal',
      'Repeated Escalation Requests': 'hasRepeatedRequestsForAgentSignal',
      'Negative Feedback': 'hasNegativeFeedbackSignal',
      'Profanity': 'hasProfanitySignal',
      'User Paraphrases': 'hasUserParaphrasesSignal',
    },
    'automation': {
      'Escalation': 'hasLiveAgentEscalationSignal',
      'User Abandoned': 'hasAbandonedByUserSignal',
      'Escalation not Connected': 'hasEscalationRequestedNotConnectedSignal',
      'False Positives': 'hasFalsePositiveSignal',
      'Negative Feedback': 'hasNegativeFeedbackSignal',
    },
  },
};

export default WyConstants;